import { r as registerInstance, f as forceUpdate, h, H as Host } from './index-ih07wrgW.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-ddkg-Itl.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Enable file upload in the form
         */
        this.fileUpload = false;
        /**
         * data that should be prefilled in the form
         * @optional
         */
        this.prefillData = null;
        /**
         * The locale to use for translations and the phone input
         */
        this.locale = "en-US";
        /**
         * Environment string to decide which endpoints to use
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * open modal automatically
         */
        this.open = false;
        /** URL to be opened when the modal is closed */
        this.reloadUrl = "";
        /**
         * origin application of the request, e.g. 'oseon' or 'MyTRUMPF'
         */
        this.origin = "";
        this.submitted = false;
        this.handleModalClose = () => {
            this.open = false;
            if (this.reloadUrl && this.reloadUrl.length > 0) {
                window.location.href = this.reloadUrl;
                return;
            }
            window.location.reload();
        };
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    componentDidLoad() {
        if (this.open) {
            this.modal.triggerOpen();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    handleServiceCaseShowSuccess() {
        this.submitted = true;
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        return (h(Host, { key: 'c1cf5f43330a695c2c8e3bf6f6018e84cc8db178' }, h("ux-modal", { key: '50a19e4180164d628057f667c4cecc27427622d9', onUxModalClose: () => this.handleModalClose(), onUxModalOpen: () => (this.open = true), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '29be586d3d871e4003e5930221ed0d1b0946c34e' }, this.open && (h("mf-create-service-case", { key: '6c755f87490c8ea18eac8ce99c0a4b8a7e56cf53', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi, origin: this.origin }, h("slot", { key: 'fe65b8ad0331fd7360e0a3d094ad5e9a6fd89e17', name: "connector" })))), this.submitted && (h("ux-modal-footer", { key: 'f452f38052e059bdc535cab1598fac559c1a0c07' }, h("ux-button", { key: '98766fef6b96d636d1fa401b3cf340bcaa892176', variant: "primary", onClick: () => {
                this.modal.triggerClose();
            } }, t("button.ok")))))));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };
//# sourceMappingURL=mf-create-service-case-modal.entry.js.map

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map